"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iWeatherData = void 0;
const t = require("io-ts");
const Location = require("./location");
const _iWeatherData = t.interface({
    geoId: t.string,
    temperature: t.number,
    weatherSymbol: t.number,
    coordinates: Location.iCoordinates,
    time: t.string
});
exports.iWeatherData = t.clean(_iWeatherData);
//# sourceMappingURL=weather.js.map